const Status = {
    TRAINING_COMPLETED: "trainingcompleted",
    PENDING_CERT_UPLOAD: "pendingforcertificateupload",
    PENDING_LETT_UNDERTAKING: "pendingforletterofundertaking",
    PENDING_FOR_APPROVAL: "pendingforapproval",
    PENDING_FOR_ADMIN_APPROVAL: "pendingfortrainingadminapproval",
    PENDING_FOR_GM_APPROVAL: "pendingforgmapproval",
    PENDING_FOR_MANAGER_APPROVAL: "pendingformanagerapproval",
    PENDING_FOR_SUPERVISOR_APPROVAL: "pendingforsupervisorapproval",
    PENDING_FOR_PTE1: "pendingforpre-trainingevaluation",
    PENDING_FOR_PTE2: "pendingforpost-trainingevaluation",
    PENDING_FOR_PTE3: "pendingforpost-trainingfurtherevaluation",
    PENDING_FOR_PTE1_APPROVAL: "pendingforpte1approval",
    PENDING_FOR_PTE2_APPROVAL: "pendingforpte2approval",
    PENDING_FOR_PTE3_APPROVAL: "pendingforpte3approval",
    PENDING_FOR_CERT:"pendingforcertificateapproval",
    PENDING_TRAIN_BOND:"pendingfortrainingbondupload",
    PENDING_TRAIN_BOND_UPLOAD:"pendingfortrainingbondupload",
    PENDING_FOR_COURSE_QUESTIONNAIRE: "pendingforcoursequestionnaire",
    // PENDING_REVIEW_COURSE_QUESTIONNAIRE: "pending for course questionnaire review",	
    PENDING_REVIEW_COURSE_QUESTIONNAIRE: "pendingforcoursequestionnaireapproval",	
    PENDING_FOR_COURSE_COMPLETION: "pendingforupdatecoursecompletion",
    PENDING_FOR_PTE1_ACKNOWLEDGE: "pendingforpte1acknowledgement",
    PENDING_FOR_PTE2_ACKNOWLEDGE: "pendingforpte2acknowledgement",
    PENDING_FOR_PTE3_ACKNOWLEDGE: "pendingforpte3acknowledgement",
    PENDING_FOR_LOU: "pendingforlousubmission",
    PTE1_UPDATE : "pendingforpte1update",
    PTE2_UPDATE : "pendingforpte2update",
    PTE3_UPDATE : "pendingforpte3update",
    PTE1_REWORK : "pendingforpte1rework",
    PTE2_REWORK : "pendingforpte2rework",
    PTE3_REWORK : "pendingforpte3rework",
    TRAINING_REJECTED: "trainingrejected",
    TRAINING_CANCELLED: "trainingcancelled",
    PTE1_UPDATED: "pte1updated",
    PTE2_UPDATED: "pte2updated",
    PTE3_UPDATED: "pte3updated",

    WAITING_FOR_PTE2: "waitingforpte2",
    WAITING_FOR_PTE3: "waitingforpte3",
    PTE_COMPLETED: "ptecompleted",

    SUBMITTED: "submitted",
    PENDING_FOR_CQ_REVIEW: "pending for cq review",
    COMPLETED_STATUS: "completed",

    TR_BOND : "TrainingBond",
    APPROVAL : "TrainingRequest",
    PTE1 : "PTE1",
    PTE2 : "PTE2",
    PTE3 : "PTE3",
    CER_APPORVAL : "Certificate Approval",
    UPDATE_COURSE : "Course Completion",
    COMPLETED : "Completed",
    LOU : "LOU",
    COURSE_QUESTIONAIRE : "Course Questionnaire",

    ACTIVE_STATUS : "active",
    INACTIVE_STATUS : "inactive"
   };

  export default Status;
  
